import React from 'react';
import { Link } from 'react-router-dom';
interface CardProps {
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  link?: {
    text: string;
    url: string;
  };
  className?: string;
}
const Card = ({
  title,
  icon,
  children,
  link,
  className = ''
}: CardProps) => {
  return <div className={`gradient-border p-6 transition-all duration-300 hover:shadow-gold-md group ${className}`} data-id="element-101">
      {icon && <div className="mb-4 text-primary transition-all duration-300 group-hover:text-gold-glow group-hover:scale-110" data-id="element-102">
          {icon}
        </div>}
      <h3 className="text-text-primary font-display font-bold mb-3 tracking-wide uppercase text-lg" data-id="element-103">
        {title}
      </h3>
      <div className="text-text-secondary font-body mb-4 leading-relaxed" data-id="element-104">
        {children}
      </div>
      {link && <Link to={link.url} className="text-primary font-display font-semibold hover:text-gold-glow inline-flex items-center transition-all duration-200 text-sm tracking-wider group/link" data-id="element-105">
          {link.text}
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-2 transition-transform duration-200 group-hover/link:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-106">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-107" />
          </svg>
        </Link>}
    </div>;
};
export default Card;